import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";

import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { FiSearch } from "react-icons/fi";
import { FaBook } from "react-icons/fa";
import { ImFolderOpen } from "react-icons/im";

import { toast } from "react-toastify";
import { STUDENT_COURSE_API } from "../../../api/api";

import uiuxdesigner from "../../../assets/student/home-uiux.png";
import data from "../../../assets/student/home-data.png";
import digital from "../../../assets/student/home-digital.png";
import mern from "../../../assets/student/home-mern.png";
// import frontend from "../../../assets/student/home-frontend.png";
// import backend from "../../../assets/student/home-backend.png";

import frontend from "../../../assets/publicpageimg/frontend-course.png";
import backend from "../../../assets/publicpageimg/backend-course.png";

// import StudentcertificateCard from "../../../assets/student/no-certificates.png";
import NotFoundCourse from "../../../assets/icons/student/course.svg";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./StudentCourses.css";

const StudentCourses = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("ALL");
  const [searchCourse, setSearchCourse] = useState("");
  const [courses, setCourses] = useState([]);
  const [courseStats, setCourseStats] = useState({});

  //loading
  const [loadingAllCourses, setAllCoursesLoading] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    // Map categories to local images
    const courseImages = {
      "Frontend Development": frontend,
      "Backend Development": backend,
      "MERN Stack Web Development": mern,
      "Digital Marketing": digital,
      "Data Analytics": data,
      "UI/UX Designer": uiuxdesigner,
    };

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setAllCoursesLoading(false);
      navigate("/signin");

      return;
    }

    const fetchCourses = async () => {
      try {
        const response = await axios.post(
          STUDENT_COURSE_API.GET_ALL_COURSES_WITH_ENROLL_STATUS,
          { student_id: userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          const apiCourses = (data.result || []).map((course) => ({
            courseId: course.course_id,
            courseTitle: course.course_title,
            courseDescription: course.course_description,
            coursePrice: course.price,
            courseLevel: course.level,
            categoryName: course.category_name,
            courseImage: courseImages[course.course_title] || "",
            studentCourseId: course.student_course_id,
            is_enrolled: course.is_enrolled,
            is_course_completed: course.is_course_completed,
          }));
          setCourses(apiCourses);
          setCourseStats(data.stats || {});
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setAllCoursesLoading(false);
      }
    };

    fetchCourses();
  }, [navigate]);

  const filteredCourses = useMemo(() => {
    return courses
      .filter((course) => {
        if (activeTab === "ENROLLED")
          return course.is_enrolled && course.studentCourseId !== null;

        if (activeTab === "COMPLETED") return course.is_course_completed;

        return true; // ALL
      })

      .filter((course) =>
        (course.courseTitle?.toLowerCase() || "").includes(
          searchCourse.trim().toLowerCase(),
        ),
      );
  }, [courses, activeTab, searchCourse]);

  const enrolledCount = useMemo(
    () =>
      courses.filter((c) => c.is_enrolled && c.studentCourseId !== null).length,
    [courses],
  );

  const completedCount = courses.filter((c) => c.is_course_completed).length;

  if (loadingAllCourses) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Container fluid className="student-certificate-section-container">
      <Row className="align-items-center mb-3">
        <h2 className="student-certificate-section-title">My Courses</h2>
        <p className="student-certificate-section-description">
          Continue your learning journey and track your progress across all enrolled courses.
        </p>
      </Row>

      <div className="student-certificate-banners">
        <Row className="student-certificate-banners-row">
          <Col className="student-certificate-banners-item">
            <p className="student-certificate-banners-label">Active Courses</p>
            <h2 className="student-certificate-banners-value">
              {courseStats.active_courses || "-"}
            </h2>
          </Col>

          <Col className="student-certificate-banners-item">
            <p className="student-certificate-banners-label">
              Learning Progress
            </p>
            <h2 className="student-certificate-banners-value">
              {courseStats.learning_progress || "-"}
            </h2>
          </Col>

          <Col className="student-certificate-banners-item">
            <p className="student-certificate-banners-label">
              Learner Satisfaction
            </p>
            <h2 className="student-certificate-banners-value">
              {courseStats.learner_satisfaction}
            </h2>
          </Col>
        </Row>
      </div>

      <div className="student-certificate-tabs student-courses-card-tab">
        <Row className="align-items-center">
          {/* TABS */}
          <Col md={8}>
            <div className="student-certificate-tabs-buttons">
              <button
                className={activeTab === "ALL" ? "active" : ""}
                onClick={() => setActiveTab("ALL")}
              >
                All Courses ({courses.length})
              </button>

              <button
                className={activeTab === "ENROLLED" ? "active" : ""}
                onClick={() => setActiveTab("ENROLLED")}
              >
                Enrolled Courses ({enrolledCount})
              </button>

              <button
                className={activeTab === "COMPLETED" ? "active" : ""}
                onClick={() => setActiveTab("COMPLETED")}
              >
                Completed Courses ({completedCount})
              </button>
            </div>
          </Col>

          <Col md={4} className="d-flex justify-content-end">
            <div className="student-slider-header-search">
              <input
                type="text"
                placeholder="Search Courses"
                value={searchCourse}
                onChange={(e) => setSearchCourse(e.target.value)}
              />
              <FiSearch className="student-slider-search-icon" />
            </div>
          </Col>
        </Row>
      </div>

      {/* Courses */}
      {filteredCourses.length > 0 ? (
        <Row className="mt-3 student-courses-card-rows">
          {filteredCourses.map((course) => (
            <Col
              lg={4}
              md={6}
              sm={6}
              xs={12}
              key={course.courseId}
              className="mb-4 d-flex"
            >
              <div className="student-courses-card">
                <div className="student-courses-card-image-wrapper">
                  <img
                    src={course.courseImage}
                    alt={course.courseTitle}
                    className="student-courses-card-img"
                    onClick={() => {
                      if (course.is_enrolled && course.studentCourseId) {
                        navigate(`/student/course-videos/${course.courseId}`);
                      } else {
                        navigate(`/student/course-detail/${course.courseId}`);
                      }
                    }}
                  />
                </div>

                <div className="student-courses-card-body">
                  <h6
                    className="student-courses-title"
                    title={course.courseTitle}
                  >
                    {course.courseTitle}
                  </h6>

                  <p className="student-courses-desc">
                    {course.courseDescription}
                  </p>

                  <span className="student-courses-points-span">
                    {course.categoryName}
                  </span>

                  <div className="student-courses-meta mt-2">
                    <span>
                      <FaBook /> Recorded Course
                    </span>
                    <span>
                      <ImFolderOpen /> {course.courseLevel}
                    </span>
                  </div>

                  <div className="student-courses-card-actions">
                    {course.is_enrolled && course.studentCourseId !== null ? (
                      <>
                        <Button
                          className="student-courses-btn-feedback"
                          onClick={() =>
                            navigate(`/student/feedback/${course.courseId}`)
                          }
                        >
                          Send Feedback
                        </Button>

                        <Button
                          className="student-courses-btn-continue"
                          onClick={() =>
                            navigate(
                              `/student/course-videos/${course.courseId}`,
                            )
                          }
                        >
                          Continue Learning
                        </Button>
                      </>
                    ) : (
                      <>
                        <span className="student-courses-start-price">
                          Price: ₹{course.coursePrice}
                        </span>

                        <Button
                          className="student-courses-btn-enroll"
                          onClick={() =>
                            navigate(
                              `/student/course-detail/${course.courseId}`,
                            )
                          }
                        >
                          Enroll Now
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="student-certificate-empty-box mt-2">
          <img
            src={NotFoundCourse}
            alt="No CoursesDetails"
            className="student-certificate-empty-icon"
          />
          <h5 className="student-certificate-empty-title">
            No Courses Available
          </h5>
          <p className="student-certificate-empty-desc">
            You don't have any courses yet.
          </p>
        </div>
      )}
    </Container>
  );
};

export default StudentCourses;
